import { render } from "./MultipleResponses.vue?vue&type=template&id=cb3e7c7c&scoped=true"
import script from "./MultipleResponses.vue?vue&type=script&lang=js"
export * from "./MultipleResponses.vue?vue&type=script&lang=js"

import "./MultipleResponses.vue?vue&type=style&index=0&id=cb3e7c7c&scoped=true&lang=css"

import exportComponent from "E:\\Dev\\Univ\\vueQuizzly\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb3e7c7c"]])

export default __exports__